export type RechargePackage = {
  id: number | string;
  amount: number | string;
  credits: number | string;
  base_credits?: number | string;
  sale_active?: boolean;
  sale_multiplier?: number | string;
};

export type CreditSale = {
  active?: boolean;
  multiplier?: number | string;
  label?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
};

export const formatCreditAmount = (amount: number | string): string => {
  const numericAmount = Number(String(amount).replace(/[^0-9.]/g, ''));
  if (!Number.isFinite(numericAmount)) {
    return String(amount || '');
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(numericAmount);
};

export const formatCredits = (credits: number | string): string => {
  const numericCredits = Number(credits);
  if (!Number.isFinite(numericCredits)) {
    return String(credits || '0');
  }

  return new Intl.NumberFormat('en-US').format(numericCredits);
};

export const isRechargeSaleActive = (sale?: CreditSale | null): boolean => {
  const multiplier = Number(sale?.multiplier || 1);
  return Boolean(sale?.active) && Number.isFinite(multiplier) && multiplier > 1;
};

export const hasRechargePackageSaleBoost = (
  creditPackage: RechargePackage,
  sale?: CreditSale | null
): boolean => {
  if (!isRechargeSaleActive(sale) && !creditPackage.sale_active) {
    return false;
  }

  const baseCredits = Number(creditPackage.base_credits ?? creditPackage.credits);
  const displayCredits = Number(creditPackage.credits);

  return Number.isFinite(baseCredits) && Number.isFinite(displayCredits) && displayCredits > baseCredits;
};
